<template>
  <div>
    <router-view v-slot="{ Component, route }" class="app-content">
      <transition :name="route.meta.noTransition ? '' : 'fade'" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
@import "./assets/vw";
body{
  margin: 0;
}
#app{
  width: vw(375);
  height: 100vh;
  overflow: auto;
  background-image: url("./assets/img/bg.png");
  background-size: cover;
  color: #FFFFFF;
  background-color: #fff;
  //max-width: 540px;
}
.app-content{
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  height: 100vh;
}
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from{
  transform: translateX(-100%);
}
.fade-enter-to{
  transform: translateX(0);
}
.fade-leave-from{
  transform: translateX(0);
}
.fade-leave-to {
  transform: translateX(100%);
}
</style>
